<template>
  <main role="main">
    <div id="app-container">
      <div id="app">
        <TheNotifications />
        <div class="container">
          <div class="container">
            <div class="row justify-content-between mb-4 mt-3">
              <TheHomeIcon />
              <TheMenu
                v-if="isEmailApproved && user && token"
                :title="user.first_name + ' ' + user.last_name"
              />
            </div>
          </div>
          <TheSpinner v-if="isLoading" size="large" line-fg-color="#eb8c00" />
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
        <TheCookieConsent cookie-name="ssta_cookieconsent" />
        <TheFooter />
      </div>
    </div>
  </main>
</template>

<script>
import { defineAsyncComponent } from 'vue';
const TheMenu = defineAsyncComponent(() => import('@/components/TheMenu.vue'));
const TheHomeIcon = defineAsyncComponent(() => import('@/components/TheHomeIcon.vue'));
const TheFooter = defineAsyncComponent(() => import('@/components/TheFooter.vue'));
const TheCookieConsent = defineAsyncComponent(() => import('@/components/TheCookieConsent.vue'));
const TheSpinner = defineAsyncComponent(() => import('@/components/TheSpinner.vue'));
const TheNotifications = defineAsyncComponent(() => import('@/components/TheNotifications.vue'));

import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    TheMenu,
    TheHomeIcon,
    TheSpinner,
    TheNotifications,
    TheCookieConsent,
    TheFooter,
  },
  data() {
    return {
      prevHeight: 0,
    };
  },
  computed: {
    ...mapState({
      isEmailApproved: 'isEmailApproved',
      user: 'user',
      isLoading: 'isLoading',
      token: 'token',
    }),
  },
  watch: {
    $route(to) {
      document.title =
        to.meta.title ||
        'Vialto Partners - Social Security Travel Assistant - Solution for Social Security Compliance';
    },
  },
};
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  @media (min-width: 576px) {
    padding-bottom: 170px;
  }
  padding-bottom: 215px;
  min-height: 100%;
  background-color: #000000;
}
html {
  overflow-y: scroll;
}

#app-container {
  position: relative;
  min-height: 100vh;
  background-color: #000000;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.error {
  text-align: center;
  font-size: 80%;
  color: #e0301e;
}
</style>
